<template lang="pug">
.wrapper.q-pb-xl
    .full-width.q-mb-lg
        base-breadcrumbs(:routeObj="routeObj")
    h1.q-mb-lg.font-24.text-weight-medium.text-grey-11
        | Акции и скидки
    template(v-for="(item, index) in modifyAdvert" :key="index")
        .font-18.q-mt-md.q-mb-sm.text-positive.text-weight-medium.cursor-pointer(@click="goToPage(item.url ? item.url : `/marketing/${item.id}?token=${item.token}`)") {{ item.title }}
        q-img.cursor-pointer.b-radius-10(v-if="!isActivAccessibility"
            :src="item.image" @click="goTo(item.url ? item.url : `/marketing/${item.id}?token=${item.token}`)" no-spinner style="max-height: 280px;"
            )
            .adv-badge.row.items-center.justify-center(@click.prevent.stop="showAdvCard(item)" v-if="item.token")
                q-icon(
                    name="etabl:info_warning"
                    size="16px"
                    color="primary"
                    @click.prevent.stop=""
                )
                .font-12.text-primary.line-height-16.q-ml-xs
                    | Реклама
            .bg-secondary.adv-card.b-radius-16.row.items-center#adv-card(v-if="showAdv && activeAdv.id == item.id" @click.prevent.stop="")
                .text-primary.font-11 
                    | {{ item.organizationName }}, ИНН {{ item.inn }}
                q-icon.q-ml-md(
                    name="etabl:copy"
                    size="14px"
                    color="positive"
                    @click="copy(`https://etabl.ru/marketing/${item.id}?token=${item.token}`)")

</template>

<script>
import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { copyToClipboard } from 'quasar';
import BaseBreadcrumbs from 'components/Base/BaseBreadcrumbs.vue';

export default {
    name: 'MarketingListDesktop',
    components: {
        BaseBreadcrumbs,
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const showAdv = ref(false);
        const activeAdv = ref(null);
        const modifyAdvert = ref([]);

        const advertisment = computed(() => store.getters['advertisement/ADVERTISMENT']);

        const isActivAccessibility = computed(() => store.getters['styles/isActiv']);

        const goToPage = (path) => {
            router.push(city.value ? `/${city.value.slug}/${path}` : `${path}`);
        };

        const goTo = (path) => {
            router.push(city.value ? `/${city.value.slug}${path}` : path);
        };

        const routeObj = computed(() => [{
            title: 'Акции и скидки',
            link: '',
        }]);

        const copy = (value) => {
            copyToClipboard(value);
        };

        const showAdvCard = (value) => {
            if(showAdv.value && activeAdv.value.id == value.id) {
                showAdv.value = false;
                activeAdv.value = null;
            } else {
                showAdv.value = true;
                activeAdv.value = value;
            }
        };
        
        onMounted(() => {
            modifyAdvert.value = advertisment.value.result.filter((item) => item.title != 'Оптика' && item.title != 'Ортопедия' && item.title != 'Электронные рецепты' && item.title != 'Средства реабилитации в салонах ортопедии' && item.title != 'Товары для красоты: VICHY, LA ROCHE-POSAY, GELTEK, BIODERMA, EMOLIUM, LIBRE DERM');

            if (process.env.CLIENT) {
                window.addEventListener('click', () => {
                    if(showAdv.value) showAdv.value = false;
                }); 

                window.addEventListener('scroll', () => {
                    if(showAdv.value) showAdv.value = false;
                });
            }
        });

        return {
            advertisment,
            goTo,
            goToPage,
            routeObj,
            showAdv,
            copy,
            showAdvCard,
            activeAdv,
            city,
            isActivAccessibility,
            modifyAdvert,
        };
    },
};
</script>

<style lang="scss" scoped>
.adv-badge {
    position: absolute;
    right: 8px;
    top: 8px; 
    background: $secondary;
    opacity: 0.7;
    width: 88px;
    padding: 4px 0;
    border-radius: 16px;
}

.adv-card {
    padding: 16px;
    top: 42px; 
    right: 8px; 
    position: absolute;
    opacity: 1;
}
</style>
